export default "__VITE_ASSET__928039f6__"